module.exports = __webpack_public_path__ + "media/47.b69c61dd.mp3";